import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const PlayerValuationAPI = {
	list: async (data) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayersValuations",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params: data,
		});

		return response.data;
	},
	playerList: async (id, params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayersValuations/Player/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/PlayersValuations",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayersValuations/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/PlayersValuations/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/PlayersValuations/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getPublic: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayersValuations/public/" + id,
			useAuthInterceptor: false,
		});

		return response.data;
	},
};
